import { Notification } from "@drone-js/core";
import type { FunctionComponent } from "react";
import { useStaticDataAtomValue } from "../staticDataAtom";

export const InternalUserNotification: FunctionComponent = () => {
    const {
        cmsData: {
            publish: { important, againstAgodaLegalPolicy },
        },
    } = useStaticDataAtomValue();

    return (
        <Notification
            intent="error"
            title={important}
            description={againstAgodaLegalPolicy}
            asset={{
                id: "fill.symbol.triangle-exclamation",
            }}
            density="compact"
        />
    );
};
